import React, { createContext, FC, ReactNode, useContext } from 'react';

import { Translations } from './models';

const TranslationsContext = createContext<Translations | null>(null);

type TranslationProps = {
  value: Translations;
  children: ReactNode;
};

export const TranslationsProvider: FC<TranslationProps> = ({
  value,
  children,
}) => (
  <TranslationsContext.Provider value={value}>
    {children}
  </TranslationsContext.Provider>
);

export const useTranslations = () => {
  const ctx = useContext(TranslationsContext);

  if (!ctx) {
    throw new Error(
      'useTranslations must be used within <TranslationsProvider>'
    );
  }

  return ctx;
};
